<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <p class="text-h5 text--primary">Телефон тех. поддержки  -  8 800 700-09-54</p>
                </v-col>
            </v-row>
            <v-col>
                <v-alert
                    type="info"
                >
                    Организация успешно добавлена.
                    Наши специалисты свяжутся с Вами для настройки автоматической выгрузки из ГИС ЖКХ запросов. Ожидайте.
                </v-alert>
                Пока мы обрабатываем Вашу заявку Вы можете самостоятельно ускорить интеграцию. <br/><br/>
                Для этого выполните несколько действий из личного кабинета Руководителя Вашей организации в ГИС ЖКХ для интеграции АИС24 с ГИС ЖКХ: <br/><br/>
                1. Зайдите в ГИС ЖКХ в раздел "Администрирование" -> "Предоставление прав доступа" -> "Заявки" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.1.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.1.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.1.png'))"
                ></v-img><br/>
                2. Нажмите "Предоставить доступ" -> "Оператору ИС" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.2.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.2.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.2.png'))"
                ></v-img><br/>
                3. Нажмите "Выбрать оператора ИС" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.3.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.3.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.3.png'))"
                ></v-img><br/>
                4. Введите в поле "Наименование" название организации "ЖКХ-Онлайн" через дефис и нажмите "Найти" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.4.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.4.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.4.png'))"
                ></v-img><br/>
                5. Выберите организацию "ЖКХ-Онлайн" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.5.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.5.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.5.png'))"
                ></v-img><br/>
                6. Выберите "Наименование ИС" АИС24 как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.6.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.6.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.6.png'))"
                ></v-img><br/>
                7. Нажмите на "Добавить виды информации" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.7.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.7.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.7.png'))"
                ></v-img><br/>
                8. Выберите раздел "Сведения о наличии или отсутствии у заявителя подтвержденной вступившим в законную силу судебным актом более чем 3 последних года"
                    и нажмите "Выбрать" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.8.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.8.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.8.png'))"
                ></v-img><br/>
                9. Нажмите кнопку "Отправить заявку" как показано на скриншоте ниже <br/>
                <v-img
                    class="mt-1"
                    lazy-src="@/assets/img/debtors/connect/п.9.png"
                    max-height="150"
                    max-width="250"
                    src="@/assets/img/debtors/connect/п.9.png"
                    @click="openPic(require('@/assets/img/debtors/connect/п.9.png'))"
                ></v-img>
            </v-col>

        </v-card-text>
        <v-dialog v-model="dialog" max-width="60%" @keydown.esc="cancel">
            <v-card>
                <v-img :src="pic" alt="" contain/>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name: 'AppealsConnectionPending',
    components:{},
    data(){
        return {
            isFetchingDebtConnection: false,
            dialog: false,
            pic: "",
        }
    },
    methods: {
        openPic(image) {
            this.dialog = true
            this.pic = image
        },
        cancel() {
            this.dialog = false
        }
    },
    computed: {
    }
}
</script>